import React from "react";
import { Button } from "./button";

export const InfoModal = ({ open, onClose, file }) => {
  if (!open || !file) return null;

  const truncateFileName = (name) => {
    if (!name) return "Unknown";
    return name.length > 40 ? `${name.substring(0, 40)}...` : name;
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white rounded-lg p-6 w-full max-w-lg shadow-xl">
        <h3 className="text-lg font-semibold mb-4">File Information</h3>

        <div className="max-h-96 overflow-y-auto space-y-4">
          {/* Basic Details Section */}
          <div>
            <h4 className="font-medium text-gray-900 mb-2">Basic Details</h4>
            <div className="space-y-2 text-sm">
              <div>
                <span className="font-medium">Name:</span>{" "}
                {truncateFileName(file.name)}
              </div>
              <div>
                <span className="font-medium">Description:</span>{" "}
                {file.description || "No description"}
              </div>
              <div>
                <span className="font-medium">Type:</span> {file.fileType}
              </div>
              <div>
                <span className="font-medium">Size:</span>{" "}
                {file.fileSize || "Unknown"}
              </div>
            </div>
          </div>

          {/* Metadata Section */}
          <div>
            <h4 className="font-medium text-gray-900 mb-2">Metadata</h4>
            <div className="space-y-2 text-sm">
              <div>
                <span className="font-medium">Created:</span> {file.dateCreated}
              </div>
              <div>
                <span className="font-medium">Created By:</span>{" "}
                {file.createdBy}
              </div>
              {file.chunksCount && (
                <div>
                  <span className="font-medium">Chunks:</span>{" "}
                  {file.chunksCount}
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="flex justify-end gap-2 mt-6">
          <Button
            type="button"
            className="bg-blue-500 text-white"
            onClick={onClose}
          >
            Close
          </Button>
        </div>
      </div>
    </div>
  );
};
